enum OutputAction {
    Off = "off",
    On = "on",
    Pulse = "pulse",
}

export default OutputAction;